import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { hotkey } from '#utilities/js/hotkey/hotkey.js'

const handler = object(null, {
  task (
    element
  ) {
    const { ownerDocument, dataset } = element
    const { body } = ownerDocument
    const { confirm } = dataset
    const e = one('input[name=\'act\']', body)

    e.value = 'delete'
    globals.ea_form2(e, '', confirm, null)
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}